
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mon-compte/atelier-sup",
      function () {
        return require("private-next-pages/mon-compte/atelier-sup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mon-compte/atelier-sup"])
      });
    }
  